import type { SourceType } from '@/types';

const contextColors = {
  current: '#6FB6C5',
  intermediate: '#2D4F75',
  aggressive: '#6FC58B',
};

const categoryColors = {
  energy: '#2D4F75',
  transport: '#6FB6C5',
  waste: '#2D755B',
  ippu: '#6FC58B',
  agriculture: '#752D49',
  forestry: '#C56FA8',
  development: '#2E3033',
};

const colorCodes: any = {
  'data-group-stationary-energy': '#4477B0',
  'data-group-transport': '#96D6DE',
  'data-group-waste': '#44B089',
  'data-group-ippu': '#A7E2C5',
  'data-group-agriculture': '#B0446E',
  'data-group-forestry': '#E2A7D4',
  'data-group-metric': '#45484D',
  'data-type-electricity': '#4477B0',
  'data-type-gas': '#96D6DE',
  'data-type-lpg': '#44B089',
  'data-type-coal': '#A7E2C5',
  'data-type-industrial-processes': '#B0446E',
  'data-type-product-use': '#E2A7D4',
  'data-type-petrol': '#45484D',
  'data-type-diesel': '#7AC7EA',
  'data-type-rail-freight': '#EACB41',
  'data-type-livestock': '#AD45CE',
  'data-type-horticulture': '#4477B0',
  'data-type-waste': '#96D6DE',
  'data-type-wastewater': '#44B089',
  'data-type-exotic-forestry': '#A7E2C5',
  'data-type-native-forestry': '#B0446E',
  'data-type-population': '#E2A7D4',
  'data-type-dwellings': '#45484D',
  'data-type-employment': '#7AC7EA',
  'sector-residential': '#4477B0',
  'sector-commercial-retail': '#96D6DE',
  'sector-health-education': '#44B089',
  'sector-manufacturing': '#A7E2C5',
  'sector-agriculture': '#B0446E',
  'sector-forestry': '#E2A7D4',
  'sector-infrastructure': '#45484D',
  'sub-sector-multi-unit-dwellings': '#4477B0',
  'sub-sector-single-dwellings': '#96D6DE',
  'sub-sector-commercial': '#44B089',
  'sub-sector-retail': '#A7E2C5',
  'sub-sector-education': '#B0446E',
  'sub-sector-manufacturing': '#E2A7D4',
  'sub-sector-agriculture': '#45484D',
  'sub-sector-forestry': '#7AC7EA',
  'sub-sector-air-travel': '#EACB41',
  'sub-sector-rail-freight': '#AD45CE',
  'sub-sector-marine-freight': '#4477B0',
  'sub-sector-health': '#96D6DE',
};

// The Community disclosure's source-type palette. Colour is presentation,
// keyed on the closed `SourceType` enum, and lives in the FE — the server
// ships values, never colours (the disclosure hard rule). Shared by the
// by-source table's bars (Overview) and the "summary by source" treemap.
// Hues reuse the existing brand palette above; `water` + `wastewater` are
// given distinct tones (the legacy GPC palette had no source-type keys).
const sourceColors: Record<SourceType, string> = {
  'stationary-energy': '#4477B0',
  transport: '#96D6DE',
  waste: '#44B089',
  wastewater: '#2D755B',
  water: '#6FB6C5',
  agriculture: '#B0446E',
};

// Lighten a hex colour toward white by `amount` (0 = unchanged, 1 = white).
// Used by the per-source treemap to give each activity a distinct tint of
// the one source colour (the treemap's leaves are then brightness-varied
// again by Highcharts). Presentation only.
const tint = (hex: string, amount: number): string => {
  const n = parseInt(hex.replace('#', ''), 16);
  const channels = [(n >> 16) & 0xff, (n >> 8) & 0xff, n & 0xff];
  return `#${channels
    .map((c) => Math.round(c + (255 - c) * amount))
    .map((c) => c.toString(16).padStart(2, '0'))
    .join('')}`;
};

export { contextColors, categoryColors, colorCodes, sourceColors, tint };
